<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading v-model:active="isLoading" :is-full-page="true" :height="128" :width="128" />
    </div>

    <form @submit.prevent="store" class="form-content">
        <div class="form-content-inner">
            <div class="form-col">
                <control type="hidden" v-model="work.id" :hasError="!!errors.id" id="id"/>
            </div>
            <div class="form-col">
                <field :label="$t('employee.startYear')" class="w-full md:w-1/2 px-2 " :hasError="errors.startyear">
                    <control type="number" v-model="work.startyear"/>
                </field>
                <field :label="$t('employee.endYear')" class="w-full md:w-1/2 px-2 mb-1 md:mb-0" :hasError="errors.endyear">
                    <control type="number" v-model="work.endyear"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="'Employer'" class="w-full md:w-1/2 px-2 " :hasError="errors.date_start">
                    <control type="text" v-model="work.place"/>
                </field>
                <field :label="'Last Position'" class="w-full md:w-1/2 px-2 mb-1 md:mb-0" :hasError="errors.date_end">
                    <control type="text" v-model="work.position"/>
                </field>
            </div>
            <div class="form-col">
                <field :label="'Last Salary'" class="w-full md:w-1/2 px-2 " :hasError="errors.date_start">
                    <control type="number" v-model="work.salary"/>
                </field>
                <field :label="'Recommendation File'" class="w-full md:w-1/2 px-2 mb-1 md:mb-0" :hasError="errors.date_end">
                    <input type="file" accept="application/pdf" v-on:change="onFileChange" class="form-control-file" id="my-file">
                </field>
            </div>
            <div class="form-col">
                <field :label="$t('vaccines.description')" class="w-full md:w-2/2 px-2 mb-1 md:mb-0">
                    <control type="text" v-model="work.remarks"/>
                </field>
            </div>
            <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
                <jb-buttons class="buttons-action-submit">
                    <jb-button type="submit" color="info" :icon="mdiCheckBold" :label="$t('finance.button.btnSubmit')" class="form-submit-btn" />
                    <jb-button type="button" color="info" outline :label="$t('finance.button.btnReset')" class="form-noicon-btn btn-reset" @click="reset()" />
                </jb-buttons>
            </div>
        </div>
    </form>
</template>
<script>
/* eslint-disable */
import { ref, reactive, onMounted, onBeforeMount, watch, watchEffect } from 'vue'
import { axiosDocument } from "@/boot/axios";
import axios from 'axios'
import { mdiBallot, mdiCheckBold } from '@mdi/js'
import { useStore } from 'vuex'
import Control from '@/components/Control'
import { useRouter } from 'vue-router'
import JbButton from '@/components/JbButton'
import JbButtons from '@/components/JbButtons'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main\.css'
import Loading from 'vue-loading-overlay'
export default {
    name: 'ClassForm',
    components: {
        Field,
        Datepicker,
        Control,
        JbButton,
        JbButtons,
        Loading
    },
    props: {
        showEdit: { Boolean },
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        },
        propObject: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    data: function () {
        return {
        }
    },
    emits: ['close-modal', 'submit', 'refresh-list'],
    setup (props, { emit }) {
        const titleStack = ref(['Admin', 'Forms'])
        const isLoading = ref(false)

        const toast = useToast()

        const router = useRouter()

        const errors = ref([])
        const options = ['ID Card', 'Family Card', 'Passport', 'TIN']
        const preview = ref('')

        const str = useStore()
        const userlogin = localStorage.getItem('name')

        const work = reactive({
            id: '',
            startyear: '',
            endyear: '',
            place: '',
            position: '',
            salary: '',
            remarks: '',
            created_by: '',
            updated_by: ''
        })

        const customElementsForm = reactive({
            checkbox: ['lorem'],
            radio: 'one',
            is_active: [1],
            file: null
        })

        const resetForm = () => {
            work.id = ''
            work.startyear = ''
            work.endyear = ''
            work.place = ''
            work.position = ''
            work.salary = ''
            work.remarks = ''
        }

        const onFileChange = async (event, evt) => {
            const file = event.target.files[0]
            if (file) {
                if (file.type !== 'application/pdf') {
                    alert('Only PDF files are allowed');
                    event.target.value = ''
                }
                else if (file.size > 1024 * 1024) {
                    alert('File too big (> 1MB)')
                    file.value = ''
                } else {
                    const reader = new FileReader()
                    reader.onloadend = function () {
                        preview.value = reader.result
                }
                reader.readAsDataURL(file)
                }
            } else {
                preview.value = ''
            }
        }

        const store = async () => {
            isLoading.value = true
            const url = props.showEdit ? 'workexp/' + work.id : 'workexp';
            const method = props.showEdit ? "PUT" : "POST";
            work.created_by = userlogin
            work.file = preview.value

            const jsonData = JSON.stringify(work)

            const configHeaders = {
                "content-type": "application/json",
                "Accept": "application/json"
            };

            await axios({
                    method,
                    url,
                    data: jsonData,
                    headers: configHeaders
                })
                .then(response => {
                    if(response.data.is_doc > 0){
                        storeDoc(response.data.link_doc)
                    } else {
                        if (response.data.success) {
                            emit('close-modal')
                            emit('refresh-list')
                            resetForm()
                            toast.success(response.data.message)
                        } else {
                            errors.value = response.data.messages
                            toast.error(response.data.messages)
                        }
                        isLoading.value = false
                    }
                })
                .catch(error => {
                    if (error.response) {
                        console.log(error)
                        toast.error(error.response.data.message)
                        console.log(JSON.stringify(error.request))
                    } else if (error.message) {
                        console.log(error.message)
                        toast.error(error.message)
                        console.log(JSON.stringify(error.message))
                    }
                    isLoading.value = false
                })
        }

        // if doc academic active = true
        const storeDoc = (env) => {
            const url = 'doc-file-employee'
            const method = 'POST'

            isLoading.value = true
            const paramsData = {
                link_doc: env
            }
            const jsonData = JSON.stringify(paramsData)
            console.log('paramsData DOC', paramsData)

            const configHeaders = {
                'content-type': 'application/json',
                Accept: 'application/json'
            }

            axiosDocument({
                method,
                url,
                data: jsonData,
                headers: configHeaders
            })
            .then(response => {
                isLoading.value = false
                emit('close-modal')
                emit('refresh-list')
                resetForm()
                toast.success(response.data.message)
            })
            .catch(error => {
                isLoading.value = false
                console.log('error', error)
            })
        }

        onBeforeMount(() => {
        })

        onMounted(() => {
            // work.value =toRefs(props, 'propClass')
        })

        watch(() => props.propClass, (newVal, oldVal) => {
            work.file = ''
            work.description = ''
        })

        watchEffect(() => {
            const newobject = props.propObject
            Object.assign(work, newobject)

            if (!props.showEdit) {
                work.id = null
                work.startyear = null
                work.endyear = null
                work.place = null
                work.position = null
                work.salary = null
                work.remarks = null
            }

            const newwork = props.propClass
            work.submenu = newwork.submenu
            work.ein = newwork.ein
            work.employee_id = newwork.employee_id
            work.nickname = newwork.nickname
        })

        return {
            titleStack,
            onFileChange,
            customElementsForm,
            mdiBallot,
            mdiCheckBold,
            options,
            router,
            work,
            store,
            toast,
            userlogin,
            errors,
            resetForm
        }
    },
    methods: {
        // async store () {
        //     const dataForm = {
        //         id: this.work.id,
        //         name: this.work.name,
        //         academic_year_id: this.work.academic_year_id,
        //         capacity: this.work.capacity,
        //         homeroom_id: this.work.homeroom_id ?? this.work.level_id,
        //         is_active: this.customElementsForm.is_active ?? false,
        //         remarks: this.work.remarks,
        //         level_id: this.work.level_id,
        //         department_id: this.work.department_id,
        //         remarks1: this.work.remarks1,
        //         remarks2: this.work.remarks2,
        //         remarks3: this.work.remarks3,
        //         created_by: 'admin',
        //         updated_by: this.work.updated_by
        //     }
        //     // await axios
        //     //     .post('class', dataForm)
        //     //     .then(response => {
        //     //         if (response.data.success) {
        //     //         } else {
        //     //             this.errors = response.data.messages
        //     //         }
        //     //     })
        //     //     .catch(error => {
        //     //         if (error.response) {
        //     //             console.log(error)
        //     //             console.log(JSON.stringify(error.request))
        //     //         } else if (error.message) {
        //     //             console.log(error.message)
        //     //             console.log(JSON.stringify(error.message))
        //     //         }
        //     //     })
        // },
        clearForm () {
            this.work = reactive({
                id: '',
                description: '',
                created_by: ''
            })
        },
        onChange: function (department_id, event) {
            if (event.target.value) {
                department_id = event.target.value
            }
            this.levelListFilter = this.levelList.filter(item => item.department_id === department_id)
            this.academicYearListFilter = this.academicYearList.filter(item => item.department_id === department_id)
        }
    },
    created () {
        this.levelListFilter = this.levelList
        this.academicYearListFilter = this.academicYearList
    }
}
</script>
